import { formatDate } from '@strata/helper-functions';
import { GridWithSearch, SecondaryData } from '@strata/react-grid';
import { HomeScreen } from '@strata/react-page-templates';
import { useNavigate } from 'react-router';

import { ListPageHeader } from 'components/ListPageHeader';
import {
    ApplicationDisplayTextMap,
    formatDisplayColText,
} from 'pages/homeScreenMessaging/HomeScreenHelpers';
import { CREATE_ROUTE } from 'services/constants';
import { useGet } from 'services/Http';

const columns = [
    {
        header: 'Published Date',
        accessorKey: 'publish_date',
        size: 130,
        cell: ({ getValue }) => <SecondaryData data={formatDate(getValue())} />,
    },
    {
        header: 'End Date',
        accessorKey: 'end_date',
        size: 100,
        cell: ({ getValue }) => <SecondaryData data={formatDate(getValue())} />,
    },
    { header: 'Announcement Type', accessorKey: 'message_category', size: 170 },
    { header: 'Announcement', accessorKey: 'message', size: 280 },
    {
        header: 'Applications',
        accessorKey: 'application',
        size: 160,
        cell: ({ getValue }) => <SecondaryData data={ApplicationDisplayTextMap[getValue()]} />,
    },
    {
        header: 'Display',
        accessorKey: 'display',
        size: 80,
        cell: ({ getValue }) => <SecondaryData data={formatDisplayColText(getValue())} />,
    },
    { header: 'Created By', accessorKey: 'created_by', size: 190 },
    { header: 'Last Modified By', accessorKey: 'last_modified_by', size: 190 },
];

export const AnnouncementList = () => {
    const navigate = useNavigate();

    const messages = useGet(
        `/announcement/admin/home_screen/message/type/${HomeScreen.MessageType.ANNOUNCE}`,
    );

    return (
        <div className="sds_main-content__container">
            <ListPageHeader
                pageTitle="Announcements"
                buttons={[
                    {
                        label: 'Create Announcement',
                        path: `/home-screen-messaging/announcements/${CREATE_ROUTE}`,
                    },
                ]}
            />
            <div className="sds_main-content__grid">
                <GridWithSearch
                    data={messages}
                    isLoading={!messages}
                    columns={columns}
                    sortProperties={[{ id: 'publish_date', desc: true }]}
                    onRowClick={(row) =>
                        navigate(`/home-screen-messaging/announcements/${row.message_id}`)
                    }
                />
            </div>
        </div>
    );
};
